/**
 * PARTS STORE
 */

import api from "Api";

const state = {
    page: {},
    part: null,
    parts: JSON.parse(localStorage.getItem("parts")) || null,
    parts_spec: null,
    parts_files: null,
    parts_stations: null,
    parts_filter: {
        search: "",
        company_id: "",
        page_size: 0,
        page_num: 1,
    },
    parts_spec_type: null,
    parts_spec_types: JSON.parse(localStorage.getItem("parts_spec_types")) || null,
    parts_spec_types_filter: {
        search: "",
        page_size: 0,
        page_num: 1,
    },
    files_categories: null,
};

// getters
const getters = {};

// actions
const actions = {
    async fetchPart({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitPart", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitPart", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutatePart", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
    async uploadPartPhoto({ rootState, commit }, payload) {
        try {
            let response = await api.post(payload.url, payload.body);

            if (typeof response !== "undefined") {
                if (payload.commit) {
                    commit("commitPart", {
                        property: payload.stateProperty,
                        with: _.get(response.data, payload.dataProperty ? payload.dataProperty : payload.stateProperty),
                    });
                    if (payload.localStorage) {
                        localStorage.setItem(
                            payload.stateProperty,
                            JSON.stringify(_.get(response.data, payload.dataProperty ? payload.dataProperty : payload.stateProperty))
                        );
                    }
                }
                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitPart(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutatePart(state, payload) {
        if (payload.method == "post" && payload.with) {
            // allows to find path with depth
            let property = _.get(state, payload.property);
            _.set(state, `${payload.property}[${(property || []).length}]`, payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_id = payload.id ? payload.id : payload.with[payload.pk];
            let property = _.get(state, payload.property);
            let curr_item = property[property.findIndex((obj) => obj[payload.pk] == curr_id)];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            let property = _.get(state, payload.property);
            property.splice(
                property.findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
            _.set(state, payload.property, property.length ? property : null);
        }
    },
    resetParts(state) {
        // take the state values and set them back to default except for the rules_
        state.page = {};
        state.part = null;
        state.parts = JSON.parse(localStorage.getItem("parts")) || null;
        state.parts_spec = null;
        state.parts_files = null;
        state.parts_stations = null;
        state.parts_filter = {
            search: "",
            company_id: "",
            page_size: 0,
            page_num: 1,
        };
        state.parts_spec_type = null;
        state.parts_spec_types = JSON.parse(localStorage.getItem("parts_spec_types")) || null;
        state.parts_spec_types_filter = {
            search: "",
            page_size: 0,
            page_num: 1,
        };
        state.files_categories = null;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
